import { useState, type ChangeEvent } from "react";
import { DebounceInput } from "react-debounce-input";

import { SearchIcon24 } from "@/components/icons";

import { calculateIsPrimaryVariant } from "@/types/filters";
import { SearchBarVariant } from "@/types/search-bar";

import { IconWrapper, SearchBarWrapperDiv } from "./search-bar.styles";

interface SearchBarProps {
    variant: SearchBarVariant;
    disabled?: boolean;
    debounceTimeout: number;
    placeholder: string;
    value: string | null;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    width?: string;
    autofocus?: boolean;
}

const SearchBar = ({
    variant = SearchBarVariant.PrimaryGrey800,
    disabled = false,
    debounceTimeout = 400,
    placeholder,
    value,
    onChange,
    width,
    autofocus = false,
    ...remainingProps
}: SearchBarProps) => {
    const [isFocused, setIsFocused] = useState(false);

    const isPrimaryVariant = calculateIsPrimaryVariant(variant);

    return (
        <SearchBarWrapperDiv variant={variant} width={width} focus={isFocused} {...remainingProps}>
            <IconWrapper>
                {isPrimaryVariant ? (
                    <SearchIcon24 width={24} height={24} />
                ) : (
                    <SearchIcon24 width={20} height={20} />
                )}
            </IconWrapper>
            <DebounceInput
                disabled={disabled}
                debounceTimeout={debounceTimeout}
                value={value || ""}
                onChange={onChange}
                placeholder={placeholder}
                autoFocus={autofocus}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
        </SearchBarWrapperDiv>
    );
};

export default SearchBar;
